export default __webpack_public_path__ + "static/media/students.97cd7213.png";